module.exports = __webpack_public_path__ + "img/map_corner-box-2.fb3d3e29.jpg";